// @styles/theme/flowbiteAccordionTheme.ts
import { createTheme } from 'flowbite-react';

export const tableTheme = createTheme({
  "root": {
    "base": "w-full text-left text-sm text-gray-900 dark:text-gray-900",
    "shadow": "absolute left-1 top-1 -z-10 h-full w-full rounded-lg bg-white custom-table-shadow",
    "wrapper": "relative overflow-y-hidden overflow-x-auto sm:overflow-x-hidden",
  },
  "body": {
    "base": "group/body",
    "cell": {
      "base": `
         p-4 group-first/body:group-first/row:first:rounded-tl-lg 
         group-first/body:group-first/row:last:rounded-tr-lg 
         group-last/body:group-last/row:first:rounded-bl-lg 
         group-last/body:group-last/row:last:rounded-br-lg 
         [&:nth-child(odd)]:bg-gray-50 [&:nth-child(even)]:bg-white
          border-b border-gray-200
        `,
    },
  },
  "head": {
    "base": "group/head text-xs uppercase text-gray-600 font-semibold dark:text-gray-600",
    "cell": {
      "base": "bg-gray-50 leading-[1.5] p-4 group-first/head:first:rounded-tl-lg group-first/head:last:rounded-tr-lg dark:bg-gray-50 border-b border-gray-200",
    },
  },
  "row": {
    "base": "group/row",
    "hovered": "hover:bg-gray-50 dark:hover:bg-gray-600",
    "striped": "odd:bg-white even:bg-gray-50 odd:dark:bg-gray-800 even:dark:bg-gray-50",
  },
});
